const SOUNDS_CONFIG = {
  enabled: true,
  masterVolume: 0.5,
  gameBoyVolume: 0.5,
}

export { SOUNDS_CONFIG };
